if (!customElements.get("location-selector-wrapper")) {
  customElements.define(
    "location-selector-wrapper",
    class LocationSelectorWrapper extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="country_code"]'),
          return_to: this.querySelector('input[name="return_to"]'),
          form: this.querySelector("form"),
          dialog: this.querySelector(".location-selector_dialog"),
          mask: this.querySelector(".location-selector_mask"),
          selectorBtns: document.querySelectorAll(".location-selector_button"),
          closeBtn: this.querySelector(".location-selector_close"),
        };
        this.elements.selectorBtns.forEach((item) => item.addEventListener("click", this.showDialog.bind(this)));
        this.elements.closeBtn.addEventListener("click", this.hideDialog.bind(this));
        this.querySelectorAll(".location-selector_regions__item").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
        document.body.appendChild(this);
      }

      showDialog() {
        this.elements.mask.classList.add("actived");
        this.elements.mask.click();
        this.elements.dialog.style.display = "flex";
      }

      hideDialog() {
        this.elements.mask.classList.remove("actived");
        this.elements.dialog.style.display = "none";
      }

      splitUrl(url) {
        try {
          const u = new URL(url);
          const pathname = u.pathname.replace(/^\/+/, ""); // 去掉开头的斜杠
          const baseUrl = `${u.protocol}//${u.host}`;
          return [baseUrl, pathname];
        } catch (e) {
          throw new Error("Invalid URL");
        }
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        const { link, isocode } = event.currentTarget.dataset;
        const [href, lang] = this.splitUrl(link);
        this.elements.input.value = isocode;
        this.elements.return_to.value = `/${lang}?_t=${isocode}`;
        form.action = href + "/localization";
        if (form) form.submit();
      }
    }
  );
}
